(function () {

    // 1. Image lazy-load
    const imageObserver = new IntersectionObserver(
        (entries, obs) => {
            entries.forEach(entry => {
                if (!entry.isIntersecting) return;

                const img = entry.target;
                img.src = img.dataset.src;
                img.onload = () => {
                    img.classList.remove('skeleton');
                    img.parentElement.classList.remove('skeleton');
                };
                img.onerror = () => {
                    img.style.display = 'none';
                    img.parentElement.classList.remove('skeleton');
                };
                obs.unobserve(img);
            });
        },
        { rootMargin: '200px' }
    );

    document.querySelectorAll('img[data-src]').forEach(img => imageObserver.observe(img));

    // 2. Section data lazy-load
    const sectionObserver = new IntersectionObserver(
        (entries, obs) => {
            entries.forEach(entry => {
                if (!entry.isIntersecting) return;

                const container = entry.target;
                const url = container.dataset.lazyContent;
                if (!url) return;

                obs.unobserve(container);
                delete container.dataset.lazyContent;

                fetch(url, { credentials: 'same-origin' })
                    .then(res => res.text())
                    .then(html => {
                        if (!html || html.trim() === '') {
                            container.closest('section')?.remove();
                            return;
                        }

                        container.innerHTML = html;

                        // Observe newly added images
                        container.querySelectorAll('img[data-src]').forEach(img => imageObserver.observe(img));

                        // Re-evaluate cards.js arrow states (no-op for non-carousel containers)
                        container.dispatchEvent(new Event('scroll'));
                    })
                    .catch(() => container.closest('section')?.remove());
            });
        },
        { rootMargin: '600px' }
    );

    document.querySelectorAll('[data-lazy-content]').forEach(el => sectionObserver.observe(el));

}());
